// extracted by mini-css-extract-plugin
export var sliderDots = "t_bz";
export var sliderDotsBlack = "t_bB";
export var sliderDotsBlue = "t_bC";
export var sliderDotsDarkBlue = "t_bD";
export var sliderDotsDarkGreen = "t_bF";
export var sliderDotsGreen = "t_bG";
export var sliderDotsLightBlue = "t_bH";
export var sliderDotsWhite = "t_bJ";